import React from "react";

import { Button } from "@partials";
import { getLocalization } from "@utilities";
import { usePagination } from "@hooks";

import { TransparentAccountDetailType as Props } from "./types";
import { ItemsList } from "./components";

const TransparentAccountDetail: React.FC<Props> = ({
  api,
  balance,
  items: defaultItems,
  localization,
  pagination: defaultPagination,
  query,
  maxVisibleDays,
  title,
  cultureCode,
}) => {
  const { hasNextItems, isLoadingMore, items, loadNextItems } = usePagination({
    api,
    defaultQuery: query,
    fetchBodyData: { maxVisibleDays },
    defaultItems,
    defaultPagination,
    cultureCode,
  });

  return (
    <div className="sm:col-14 sm:offset-1">
      <h2 className="mb-2 text-2xl text-grey-200 sm:text-3xl">{title}</h2>

      <div className="mb-6 text-lg text-grey-200 last:mb-0 sm:flex sm:font-normal">
        <span className="font-semibold">{balance.amount}</span>
        <span
          className="whitespace-pre-line sm:whitespace-pre"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: ` (${balance.date})` }}
        />
      </div>

      <ItemsList items={items} />

      {hasNextItems && (
        <Button
          template="secondary"
          title={getLocalization(localization, "transparentAccountDetail/button")}
          type="button"
          isLoading={isLoadingMore}
          onClick={loadNextItems}
          dataTestId="button-load-more"
        />
      )}
    </div>
  );
};

export default TransparentAccountDetail;
